import React, { useEffect, useState } from "react";
import "./Components/LoginPage.css";
import logo from "./Components/Images/zp logo.png";
import loginImage from "./Components/Images/Spark Final.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const LoginPage = () => {
  const [formData, setFormData] = useState({
    taluka: "",
    cluster: "",
    school: "",
    standard: "",
    standardNumber: "",
    name: "",
    parentPhoneNumber: ""
  });

  const [talukas, setTalukas] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [schools, setSchools] = useState([]);
  const [standards, setStandards] = useState([]);
  const [students, setStudents] = useState([]);
  const [exams, setExams] = useState([]);
  const [examId, setExamId] = useState('');
  const [standardId, setStandardId] = useState('');

  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  // Prevent default form submission behavior
  useEffect(() => {
    const handleFormSubmit = (e) => {
      if (e.target.tagName === 'FORM') {
        e.preventDefault();
      }
    };

    document.addEventListener('submit', handleFormSubmit);
    return () => document.removeEventListener('submit', handleFormSubmit);
  }, []);

  // Fetch all Talukas on load
  useEffect(() => {
    async function fetchTalukas() {
      try {
        const talukaRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/taluka`);
        setTalukas(talukaRes.data.items || talukaRes.data);
      } catch (error) {
        console.error("Failed to fetch talukas", error);
      }
    }
    fetchTalukas();
  }, []);

  // Fetch clusters when taluka changes
  useEffect(() => {
    async function fetchClusters() {
      if (!formData.taluka) {
        setClusters([]);
        setFormData(prev => ({ ...prev, cluster: "", school: "", standard: "" }));
        setSchools([]);
        setStandards([]);
        return;
      }

      try {
        const clusterRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/cluster/clusters-by-taluka/${formData.taluka}`
        );
        setClusters(clusterRes.data.items || clusterRes.data);
        setFormData(prev => ({ ...prev, cluster: "", school: "", standard: "" }));
        setSchools([]);
        setStandards([]);
      } catch (error) {
        console.error("Failed to fetch clusters", error);
      }
    }
    fetchClusters();
  }, [formData.taluka]);

  // Fetch schools when cluster changes
  useEffect(() => {
    async function fetchSchools() {
      if (!formData.cluster) {
        setSchools([]);
        setFormData(prev => ({ ...prev, school: "", standard: "" }));
        setStandards([]);
        return;
      }

      try {
        const schoolRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/school/schools-by-cluster/${formData.cluster}?pageNumber=1&pageSize=50`
        );
        setSchools(schoolRes.data.items || schoolRes.data);
        setFormData(prev => ({ ...prev, school: "", standard: "" }));
        setStandards([]);
      } catch (error) {
        console.error("Failed to fetch schools", error);
      }
    }
    fetchSchools();
  }, [formData.cluster]);

  // Fetch standards when school changes
  useEffect(() => {
    async function fetchStandards() {
      if (!formData.school) {
        setStandards([]);
        setFormData(prev => ({ ...prev, standard: "", standardNumber: "" }));
        return;
      }

      try {
        const standardsRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Standard/range?startId=1&endId=6`
        );
        setStandards(standardsRes.data.items || standardsRes.data);
        setFormData(prev => ({ ...prev, standard: "", standardNumber: "" }));
      } catch (error) {
        console.error("Failed to fetch standards", error);
      }
    }
    fetchStandards();
  }, [formData.school]);

  useEffect(() => {
    console.log("useEffect triggered with standardId:", standardId);

    if (standardId) {
      axios.get(`${API_BASE}/api/studentexam/exams-by-standard/${standardId}`)
        .then(res => {
          console.log("Exams fetched:", res.data);
          setExams(res.data);
        })
        .catch(err => {
          console.error("Failed to fetch exams:", err);
          setExams([]);
        });
    } else {
      setExams([]);
    }
  }, [standardId]);

  useEffect(() => {
    async function fetchStudents() {
      if (!formData.school || formData.standardNumber === null || formData.standardNumber === "") {
        setStudents([]);
        return;
      }

      console.log("Fetching students for:", {
        schoolId: formData.school,
        standardNumber: formData.standardNumber
      });

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Students/students-by-school-and-standard-number`,
          {
            params: {
              schoolId: formData.school,
              standardNumber: formData.standardNumber
            }
          }
        );
        console.log("students fetched:", res.data);
        setStudents(res.data);
      } catch (error) {
        console.error("Failed to fetch students", error);
        setStudents([]);
      }
    }
    fetchStudents();
  }, [formData.school, formData.standardNumber]);


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "standard") {
      const selectedStd = standards.find(s => (s.Id || s.id) === parseInt(value, 10));
      const number = selectedStd ? (selectedStd.Number || selectedStd.number) : null;
      console.log("Selected Standard ID:", value);
      console.log("Selected Standard Number:", number);

      setStandardId(parseInt(value, 10));

      setFormData(prev => ({
        ...prev,
        standard: value,
        standardNumber: number
      }));

      setExamId("");
    } else if (name === "school") {
      setFormData(prev => ({
        ...prev,
        school: value,
        standard: "",
        standardNumber: ""
      }));
      setStandards([]);
      setStudents([]);
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("Login attempt started");

    if (
      !formData.name.trim() ||
      !formData.taluka ||
      !formData.cluster ||
      !formData.school ||
      !formData.standard ||
      !examId
    ) {
      alert("Please fill all details before proceeding.");
      return;
    }

    const phonePattern = /^[6-9]\d{9}$/;
    if (!formData.parentPhoneNumber.trim()) {
      alert("Please enter parent's phone number.");
      return;
    } else if (!phonePattern.test(formData.parentPhoneNumber.trim())) {
      alert("Please enter a valid 10-digit Indian phone number.");
      return;
    }

    try {
      console.log("Sending registration request...");
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/studentexam/register`, {
        StudentName: formData.name.trim(),
        TalukaId: parseInt(formData.taluka, 10),
        ClusterId: parseInt(formData.cluster, 10),
        SchoolId: parseInt(formData.school, 10),
        StandardId: parseInt(formData.standard, 10),
        PaperId: parseInt(examId, 10),
        ParentPhoneNumber: formData.parentPhoneNumber.trim() || null // NEW FIELD
      });

      console.log("Full registration response:", res);
      console.log("Response data:", res.data);

      // Debug the response structure
      console.log("Response keys:", Object.keys(res.data));

      // Try different possible property names for the attempt ID
      const possibleAttemptIdKeys = ['AttemptId', 'attemptId', 'id', 'Id', 'attemptID'];
      let attemptIdValue;

      for (const key of possibleAttemptIdKeys) {
        if (res.data[key] !== undefined) {
          attemptIdValue = res.data[key];
          console.log(`Found attempt ID in key '${key}':`, attemptIdValue);
          break;
        }
      }

      if (!attemptIdValue) {
        console.error("Could not find attempt ID in response. Full response:", res.data);
        alert("Registration failed: Could not get attempt ID");
        return;
      }

      // Store data in localStorage
      localStorage.setItem("StudentId", res.data.StudentId);
      localStorage.setItem("AttemptId", attemptIdValue);
      localStorage.setItem("StudentName", res.data.StudentName);

      console.log("Navigating to ExamInstruction with attemptId:", attemptIdValue);

      // Navigate to the exam instructions page
      navigate(`/ExamInstruction/${attemptIdValue}`);

    } catch (error) {
      console.error("Registration error:", error);
      if (error.response) {
        console.error("Error response data:", error.response.data);
        alert(error.response.data || "Failed to register. Try again.");
      } else {
        alert("Failed to register. Try again.");
      }
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-left">
        <div className="Logoo">
          <div className="Logo1">
            {/* <img src={logo} alt="ZP Logo" className="logo" /> */}
          </div>
        </div>
        <form onSubmit={handleLogin}>
          <h2>Log in to start your exam.</h2>

          {/* Form fields remain the same as in your original code */}
          <label htmlFor="taluka">Taluka / तालुका </label>
          <select id="taluka" name="taluka" value={formData.taluka} onChange={handleChange}>
            <option value="">Select Taluka</option>
            {talukas.length > 0 ? talukas.map(t => (
              <option key={t.Id || t.id} value={t.Id || t.id}>{t.name || t.Name}</option>
            )) : (
              <option disabled>Loading Talukas...</option>
            )}
          </select>

          <label htmlFor="cluster">Cluster / केंद्र </label>
          <select id="cluster" name="cluster" value={formData.cluster} onChange={handleChange}>
            <option value="">Select Cluster</option>
            {clusters.length > 0 ? clusters.map(c => (
              <option key={c.Id || c.id} value={c.Id || c.id}>{c.name || c.Name}</option>
            )) : (
              <option disabled>No Clusters</option>
            )}
          </select>

          <label htmlFor="school">School / शाळा </label>
          <select id="school" name="school" value={formData.school} onChange={handleChange}>
            <option value="">Select School</option>
            {schools.length > 0 ? schools.map(s => (
              <option key={s.Id || s.id} value={s.Id || s.id}>{s.name || s.Name}</option>
            )) : (
              <option disabled>No Schools</option>
            )}
          </select>

          <label htmlFor="standard">Standard / इयत्ता </label>
          <select id="standard" name="standard" value={formData.standard} onChange={handleChange}>
            <option value="">Select Standard</option>
            {standards.length > 0 ? standards.map(std => (
              <option key={std.Id || std.id} value={std.Id || std.id}>{std.name || std.Name}</option>
            )) : (
              <option disabled>Loading Standards...</option>
            )}
          </select>

          <label htmlFor="parentPhoneNumber">Parent's Phone Number / पालकांचा फोन नंबर</label>
          <input
            type="tel"
            id="parentPhoneNumber"
            name="parentPhoneNumber"
            value={formData.parentPhoneNumber}
            onChange={(e) => setFormData(prev => ({ ...prev, parentPhoneNumber: e.target.value }))}
            placeholder="Enter parent's phone number"
          />

          <label htmlFor="name">Student Name / विद्यार्थ्याचे नाव</label>
          <select
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="student_name"
          >
            <option value="">Select Student</option>
            {students.length > 0 ? (
              students.map((s) => (
                <option key={s.id} value={s.fullName}>
                  {s.fullName}
                </option>
              ))
            ) : (
              <option disabled>No Students Found</option>
            )}
          </select>

          <label htmlFor="exam">Exam / परीक्षा</label>
          <select
            id="exam"
            name="exam"
            value={examId}
            onChange={(e) => setExamId(e.target.value)}
          >
            <option value="">Select Exam</option>
            {exams.map((exam) => (
              <option key={exam.id} value={exam.id}>
                {exam.title}
              </option>
            ))}
          </select>

          <button type="submit" className="login-button">
            Login
          </button>
        </form>
      </div>

      <div className="image-section">
        <img src={loginImage} alt="Login Visual" />
      </div>
    </div>
  );
};

export default LoginPage;
